// Gift card recipient form — shows/hides the recipient fields with the toggle
// and disables them when off so empty/unused fields never post.
if (!customElements.get("gift-recipient-form")) {
  customElements.define(
    "gift-recipient-form",
    class GiftRecipientForm extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
      }

      connectedCallback() {
        this.toggle = this.querySelector("[data-gift-toggle]");
        this.fields = this.querySelector("[data-gift-fields]");
        this.inputs = Array.from(this.querySelectorAll("[data-gift-field]"));
        this.status = this.querySelector("[data-gift-status]");
        this.toggle?.addEventListener("change", this.onToggle);
        // Start collapsed (unless the merchant/customer left it checked).
        this.apply(this.toggle?.checked || false);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener("change", this.onToggle);
      }

      onToggle() {
        this.apply(this.toggle.checked);
      }

      apply(expanded) {
        if (this.fields) this.fields.hidden = !expanded;
        this.inputs.forEach((input) => {
          input.disabled = !expanded;
        });
        if (this.status) {
          this.status.textContent = expanded
            ? this.dataset.expandedText || ""
            : this.dataset.collapsedText || "";
        }
      }
    },
  );
}
